import { useState } from "react";

export function useDisclose(initialState?: boolean) {
  const [isOpen, setOpen] = useState<boolean>(initialState || false);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);
  const onToggle = () => setOpen((status) => !status);

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
  };
}
